"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayoutConfig = void 0;
const helpers_1 = require("../../shared/helpers");
const getLayoutConfig = (stimulus, translations, mediaAssets, trialNumber) => {
    const { answer, distractors, trialType } = stimulus;
    const defaultConfig = JSON.parse(JSON.stringify(helpers_1.DEFAULT_LAYOUT_CONFIG));
    defaultConfig.playAudioOnLoad = false;
    defaultConfig.isPracticeTrial = stimulus.assessmentStage === 'practice_response';
    defaultConfig.classOverrides.buttonContainerClassList = ['lev-response-row', 'multi-stack'];
    defaultConfig.isInstructionTrial = stimulus.trialType === 'instructions';
    defaultConfig.prompt.enabled = true;
    defaultConfig.prompt.useStimText = true;
    defaultConfig.stimText = {
        value: stimulus.prompt,
        displayValue: undefined,
    };
    defaultConfig.classOverrides.stimulusContainerClassList = ['inference-scroll'];
    defaultConfig.disableButtonsWhenAudioPlaying = true;
    if (!defaultConfig.isInstructionTrial) {
        const mappedDistractors = (0, helpers_1.mapDistractorsToString)(distractors);
        const prepChoices = (0, helpers_1.prepareChoices)(answer.toString(), mappedDistractors, 'yes', trialType);
        defaultConfig.isImageButtonResponse = false;
        defaultConfig.classOverrides.buttonClassList = ['roar-inference-btn'];
        defaultConfig.response = {
            target: prepChoices.target,
            displayValues: prepChoices.choices,
            values: prepChoices.originalChoices,
            targetIndex: prepChoices.correctResponseIdx,
        };
    }
    else {
        defaultConfig.classOverrides.buttonClassList = ['primary'];
    }
    const messages = (0, helpers_1.validateLayoutConfig)(defaultConfig, mediaAssets, translations, stimulus);
    return {
        itemConfig: defaultConfig,
        errorMessages: messages,
    };
};
exports.getLayoutConfig = getLayoutConfig;
